/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Leads/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AttachLeadToPatientAction from './AttachLeadToPatientAction/index'
import CancelAction from './CancelAction/index'
import Heading from './Heading/index'
import React from 'react'
import RegisterAction from './RegisterAction/index'
import Similar from './Similar/index'
import Subheader from './Subheader/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Leads({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Lead/Content/Leads"
  
}) {
let similarLeadsValueData = fromData.useDataValue({ viewPath,
context: 'similar_leads',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaModalHeader
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<Heading
{...childProps}
  viewPath={`${viewPath}/Heading`}
/>
)}
</TysiaModalHeader>
<TysiaModalContent
  viewPath={`${viewPath}/TysiaModalContent`}
 paddingTop={0}
>
{childProps => (
<React.Fragment>
<Subheader
{...childProps}
  viewPath={`${viewPath}/Subheader`}
/>
<div
  data-testid="Leads.List"
  data-view-path={viewPath}
 style={{'--mt-1-5hT6g': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(similarLeadsValueData) && similarLeadsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="similar_lead"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Similar(${item?.id ?? item?._id ?? index})`}
      >
<Similar
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Similar(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<RegisterAction
{...childProps}
  viewPath={`${viewPath}/RegisterAction`}
/>
<AttachLeadToPatientAction
{...childProps}
  viewPath={`${viewPath}/AttachLeadToPatientAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }